<div class="row header">
    <div class="col-lg-3">
        <h1>Gestión # {{gestionSeleccionada.noPrecalificacion}}</h1>
    </div>
    <div class="col-lg-9">
        <div class="row">
            <h2> Fecha de Registro: {{gestionSeleccionada.fechaRegistro}}</h2> <h2> Fecha de Vencimiento: {{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.fechaVencimientoOferta}}</h2>
            <span class="icon icon-pen" style="width: 22.5px;height: 17px;"></span>
            <span class="icon icon-circle" style="width: 20px;height: 20px;" [ngStyle]="{'background':gestionSeleccionada.estadoColorPrecalificacion == 'VERDE' ? '#00738f':gestionSeleccionada.estadoColorPrecalificacion == 'ROJO'? '#de2460':'#ffcc01' }"></span>
            <h2 style="color:#de2460;margin-left: 5px;" *ngIf="gestionSeleccionada.estadoColorPrecalificacion == 'ROJO'">Rechazado</h2>
            <h2 style="color:#00738f;margin-left: 5px;" *ngIf="gestionSeleccionada.estadoColorPrecalificacion == 'VERDE'">Preaprobado</h2>
            <h2 style="color:#ffcc01;margin-left: 5px;" *ngIf="gestionSeleccionada.estadoColorPrecalificacion == 'AMARILLO'">Revisión</h2>
        </div>
    </div>
</div>
<div class="row participantes">
    <div class="col-md-4">
        <div class="rectangle" style="margin-left: auto;">
            <div class="row">
               <div class="col-2 p-0" style="padding-left: 35px;">
                <ngx-avatar size="40"  src="assets/images/general/avatar.png"></ngx-avatar>
               </div>
               <div class="col-10 p-0">
                   <p *ngIf="!clienteserviceParam.rolABFlag">ABF ASIGNADO</p>
                   <p *ngIf="clienteserviceParam.rolABFlag">AGENTE BANCARIO</p>
                   <h4>{{gestionSeleccionada.informacionGeneral.usuarioAbf}}</h4>
               </div>
            </div>
        </div>
    </div>
    <div class="col-md-4">
        <div class="rectangle" (click)="selectedtab(7)" style="margin-right: auto;margin-left: auto;" [ngClass]="{'rectangle-selected': participante==0,'rectangle':participante !=0}">
            <div class="row">
                <div class="col-md-2 p-0" style="padding-left: 35px;">
                    <ngx-avatar *ngIf="gestionSeleccionada.participante[0].datosGenerales.genero=='M'" size="40"  src="assets/images/general/male.png"></ngx-avatar>
                    <ngx-avatar *ngIf="gestionSeleccionada.participante[0].datosGenerales.genero=='F'" size="40"  src="assets/images/general/female.png"></ngx-avatar>
                    <ngx-avatar *ngIf="gestionSeleccionada.participante[0].datosGenerales.genero==''" size="40"  src="assets/images/general/avatar.png"></ngx-avatar>
                </div>
                <div class="col-md-10 p-0">
                    <p>CLIENTE</p>
                    <h4>{{gestionSeleccionada.participante[0].datosGenerales.primerNombre}} {{gestionSeleccionada.participante[0].datosGenerales.primerApellido}}</h4>
                    <h3>DPI: {{gestionSeleccionada.participante[0].datosGenerales.dpi}}</h3>
                </div>
             </div>
        </div>
    </div>
    <div class="col-md-4">
        <div class="rectangle" (click)="selectedtab(8)" style="margin-right: auto;" *ngIf="gestionSeleccionada.participante[1] != null" [ngClass]="{'rectangle-selected': participante==1,'rectangle':participante !=1}">
            <div class="row">
                <div class="col-md-2 p-0" style="padding-left: 35px;">
                    <ngx-avatar *ngIf="gestionSeleccionada.participante[1].datosGenerales.genero=='M'" size="40"  src="assets/images/general/male.png"></ngx-avatar>
                    <ngx-avatar *ngIf="gestionSeleccionada.participante[1].datosGenerales.genero=='F'" size="40"  src="assets/images/general/female.png"></ngx-avatar>
                    <ngx-avatar *ngIf="gestionSeleccionada.participante[1].datosGenerales.genero==''" size="40"  src="assets/images/general/avatar.png"></ngx-avatar>
                </div>
                <div class="col-md-10 p-0">
                    <p>CODEUDOR</p>
                    <h4>{{gestionSeleccionada.participante[1].datosGenerales.primerNombre}} {{gestionSeleccionada.participante[1].datosGenerales.primerApellido}}</h4>
                    <h3>DPI: {{gestionSeleccionada.participante[1].datosGenerales.dpi}}</h3>
                </div>
             </div>
        </div>
    </div>
</div>
<div class="row tabsgestion" *ngIf="!clienteserviceParam.rolABFlag">
    <button type="button" class="btn tabgestion" (click)="selectedtab(1)" [ngClass]="{'tabgestion-selected': buttonselected==1,'tabgestion':buttonselected !=1}" >Oferta Comercial</button>
    <button type="button" class="btn tabgestion" (click)="selectedtab(2)" [ngClass]="{'tabgestion-selected': buttonselected==2,'tabgestion':buttonselected !=2}">Políticas</button>
    <button type="button" class="btn tabgestion" (click)="selectedtab(3)" [ngClass]="{'tabgestion-selected': buttonselected==3,'tabgestion':buttonselected !=3}">Buró Interno</button>
    <button type="button" class="btn tabgestion" (click)="selectedtab(4)" [ngClass]="{'tabgestion-selected': buttonselected==4,'tabgestion':buttonselected !=4}">Buró Externo (SIB)</button>
    <button type="button" class="btn tabgestion" (click)="selectedtab(5)" [ngClass]="{'tabgestion-selected': buttonselected==5,'tabgestion':buttonselected !=5}">Info Pre-solicitud</button>
    <button *ngxPermissionsOnly="['descargaDeDocumentos']" type="button" class="btn tabgestion" (click)="selectedtab(6)" [ngClass]="{'tabgestion-selected': buttonselected==6,'tabgestion':buttonselected !=6}">PDF</button>

</div>
